import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, Label} from 'recharts';
import AnalyticsTooltip from './AnalyticsTooltip';

const noneLabel = "none"

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload

    return (
      <AnalyticsTooltip
        kicker="Month"
        title={data.sessionLabelFull}
        rows={[
          { label: "Closed Renegotiations", value: data.closedRenegotiations ? data.closedRenegotiations : noneLabel },
          { label: "Tier 1 Closures", value: data.tier1Renegotiations ? data.tier1Renegotiations : noneLabel },
          { label: "Tier 2 Closures", value: data.tier2Renegotiations ? data.tier2Renegotiations : noneLabel },
          { label: "Manual Closures", value: data.manualRenegotiations ? data.manualRenegotiations : noneLabel },
        ]}
      />
    );
  }

  return null;
};

export default class MonthlyOneYearChart extends PureComponent {

  render() 
  {
    return (
      <ResponsiveContainer width="100%" height="100%" minHeight={320}>
        <BarChart
          data={this.props.monthlyStatsYear}
          layout="horizontal"
          margin={{
            top: 8,
            right: 18,
            left: 18,
            bottom: 6,
          }}
        >
          <XAxis dataKey="sessionLabel" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}} />
          <YAxis dataKey="closedRenegotiations" type="number" domain={[0, dataMax => Math.round((dataMax * 1.2))]} yAxisId="right" orientation="right" stroke="#5a5c68" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}}>
            <Label angle={90} position='right' style={{ textAnchor: 'middle' }} offset={-20}>
              closed renegotiations
            </Label>
          </YAxis>
          <Tooltip content={<CustomTooltip/>} cursor={{fill: `rgba(147, 149, 153, 0.12)`}} />
          <Legend wrapperStyle={{fontSize: "0.78rem", fontWeight: 700, color: "#666C78", paddingTop: "0.35rem"}} />
          <Bar yAxisId="right" dataKey="closedRenegotiations" fill="#6e88cc" stackId="a" name="Closed Renegotiations" />
          <Bar yAxisId="right" dataKey="tier1Renegotiations" fill="#E38A86" stackId="b" name="Tier 1 Closures" />
          <Bar yAxisId="right" dataKey="tier2Renegotiations" fill="#CAABD1" stackId="b" name="Tier 2 Closures" />
          <Bar yAxisId="right" dataKey="manualRenegotiations" fill="#00B81284" stackId="b" name="Manual Closures" />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
